// Vanilla JS replacements for Bootstrap 4 jQuery components
// Bootstrap 4's JS requires jQuery, so we use native implementations instead

document.addEventListener('DOMContentLoaded', () => {
  // Collapse functionality (FAQ accordions, navbar toggle)
  document.querySelectorAll('[data-toggle="collapse"]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const targetSelector = trigger.getAttribute('data-target') || trigger.getAttribute('href');
      const target = document.querySelector(targetSelector);
      // Allow clicks inside the collapsible content (e.g. links) to behave normally
      if (target && target.contains(e.target)) {
        return;
      }
      e.preventDefault();
      if (target) {
        const isShown = target.classList.contains('show');
        target.classList.toggle('show');
        target.classList.toggle('collapse');
        target.classList.toggle('collapsing');
        trigger.setAttribute('aria-expanded', !isShown);
        
        // Handle accordion behavior (close siblings)
        const parent = trigger.getAttribute('data-parent');
        if (parent && !isShown) {
          document.querySelectorAll(`${parent} .collapse.show`).forEach(sibling => {
            if (sibling !== target) {
              sibling.classList.remove('show');
              sibling.classList.add('collapse');
            }
          });
        }
        
        // Remove collapsing class after transition
        setTimeout(() => target.classList.remove('collapsing'), 350);
      }
    });
  });

  // Dropdown functionality (Nav dropdowns)
  document.querySelectorAll('[data-toggle="dropdown"]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const parent = trigger.closest('.dropdown') || trigger.parentElement;
      const menu = parent.querySelector('.dropdown-menu');
      const isShown = menu?.classList.contains('show');
      
      // Close all other dropdowns first
      document.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'));
      document.querySelectorAll('.dropdown.show').forEach(d => d.classList.remove('show'));
      
      if (menu && !isShown) {
        menu.classList.add('show');
        parent.classList.add('show');
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.dropdown-menu.show').forEach(m => m.classList.remove('show'));
    document.querySelectorAll('.dropdown.show').forEach(d => d.classList.remove('show'));
  });

  // Alert dismiss functionality (Flash messages)
  document.querySelectorAll('[data-dismiss="alert"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const alert = btn.closest('.alert');
      if (alert) {
        alert.classList.remove('show');
        setTimeout(() => alert.remove(), 150);
      }
    });
  });
});
